import './App.css'
import { Route, Routes, Navigate, useLocation } from 'react-router-dom'
import { Box, Card, MantineProvider } from '@mantine/core'
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import { theme } from './theme/theme'
import NotFound from './modulos/paginaNoEncontrada/paginaNoEncontrada'

import FormularioAutenticacionCV from './modulos/autenticacion/controladorVista/formularioAutenticacionCV'
import { MenuBarra } from './globales/componentes/menu/menuBarra'
import { MenuModulos } from './globales/componentes/menu/menuModulos'
import { ProveedorAutenticacion, useAutenticacion } from './globales/contextos/authContext'
import { rutas } from './globales/componentes/menu/rutas'
import { RutaProtegida } from './globales/componentes/rutaProtegida/rutaProtegida'
import { ProveedorNotificacion } from './globales/contextos/notificationContext'
import { obtenerRutaPorDefecto } from './utils/rutaHelpers'
import { ProovedorConfirmacion } from './globales/contextos/confirmacionContext'
import { ProveedorCargando } from './globales/contextos/cargandoContext';
import { usePermisos } from './globales/contextos/usePermisos';
import { ProveedorAsistenteIA } from './globales/contextos/asistenteIAContext';
import { AsistenteIADrawer } from './modulos/asistenteIA/vista/asistenteIADrawer';
import { EnumPermisos } from './globales/enums/enumPermisos';

const AppContent = () => {
  const { estaAutenticado, verificandoSesion } = useAutenticacion();
  const { puedeAccederModulo, tienePermiso } = usePermisos();
  const location = useLocation();

  // Detectar si la ruta actual es de reportes
  const esReportes = location.pathname === '/Reportes' || location.pathname === '/Cliente/Reportes';
  // Detectar si la ruta actual es Agenda (case-insensitive, acepta subpaths)
  const pathLower = location.pathname.toLowerCase();
  const esAgenda = pathLower.includes('/agenda');

  if (verificandoSesion) {
    return null; // ⏳ puedes mostrar un spinner inicial si quieres
  }

  return (
    <div className="app-container">
      {estaAutenticado && !verificandoSesion && (
        <>
          <MenuBarra />
          <MenuModulos />
        </>
      )}
      <div style={{ display: 'flex', flex: 1, overflow: 'hidden', width: '100%', position: 'relative' }}>
        <main className="main-content">
          <Routes>
            <Route
              path="/"
              element={
                estaAutenticado
                  ? <Navigate to={obtenerRutaPorDefecto(puedeAccederModulo)} replace />
                  : <Navigate to="/ingresar" replace />
              }
            />

            <Route
              path="/ingresar"
              element={
                estaAutenticado
                  ? <Navigate to={obtenerRutaPorDefecto(puedeAccederModulo)} replace />
                  :
                  <FormularioAutenticacionCV />
              }
            />

            {rutas.filter(r => r.Activa && puedeAccederModulo(r.PermisoRequerido)).map(ruta => (
              <Route
                key={ruta.Ruta}
                path={ruta.Ruta}
                element={
                  <RutaProtegida>
                    {/* Contenedor que ocupa el espacio restante del main */}
                    <Box style={{
                      display: 'flex',
                      flexDirection: 'column',
                      height: '100%',
                      padding: '20px'
                    }}>
                      <Card
                        radius="md"
                        p={esReportes ? 0 : 'md'}
                        shadow="sm"
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          background: '#fff',
                          overflow: 'hidden',
                          width: '100%',
                          height: esReportes || esAgenda ? '100%' : 'auto',   // Para reportes, altura completa
                          maxHeight: '100%',   // No crece más que el espacio disponible en el main
                          margin: '0 auto',
                        }}
                      >
                        <Box
                          p={0}
                          style={{
                            flex: 1, // Cuando el Card está limitado por maxHeight, este Box llenará el espacio y hará scroll
                            overflowY: esAgenda ? 'hidden' : 'auto',
                            minHeight: 0,
                          }}
                        >
                          {ruta.Componente}
                        </Box>
                      </Card>
                    </Box>
                  </RutaProtegida>
                }
              />
            ))}

            <Route
              path="*"
              element={
                estaAutenticado
                  ? <Box style={{
                      display: 'flex',
                      flexDirection: 'column',
                      height: '100%',
                      padding: '20px'
                    }}>
                      <Card radius="md" p="md" shadow="sm" style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <NotFound />
                      </Card>
                    </Box>
                  : <Navigate to="/ingresar" replace />
              }
            />
          </Routes>
          {/* 👇 Ya no necesitas poner LoadingOverlay aquí */}
        </main>
        {estaAutenticado && !verificandoSesion && tienePermiso(EnumPermisos.PERMISO_ASISTENTE_IA_VER) && <AsistenteIADrawer />}
      </div>
    </div>
  );
};

function App() {
  return (
    <MantineProvider theme={theme}>
      <ProovedorConfirmacion>
        <ProveedorCargando>
          <ProveedorAutenticacion>
            <ProveedorNotificacion>
              <ProveedorAsistenteIA>
                <AppContent />
              </ProveedorAsistenteIA>
            </ProveedorNotificacion>
          </ProveedorAutenticacion>
        </ProveedorCargando>
      </ProovedorConfirmacion>
    </MantineProvider>
  )
}

export default App
